// extracted by mini-css-extract-plugin
export default {"greycard":"GreyCard_greycard__KjlYB"};